<template>
  <Modal :title="title" :showModal="showModal" class="edit-manufacture-form manufacture-form large">
    <template v-slot:body>
      <div class="popup-wrap">
        <a href="#close" class="close-modal" data-dismiss="modal" @click.prevent="$emit('close', {})"></a>
        <Gallery :value="galleryConfig.gallery" :groups="galleryConfig.groups" :config="galleryConfig.config" />
        <div class="main-container d-block p-3">
          <Detail :config="{ storeId, manufactureId, data, loaded }" @change-preview="blueprint = $event" @close="$emit('close', $event)"></Detail>
          <div class="form-group w-100">
            <Comment :config="data"></Comment>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import Event from '@/helper/event.js'
import Comment from './Comment.vue'
import Detail from './Detail.vue'
import Gallery from '@/components/Gallery.vue'
export default {
  mixins: [Event],
  components: {
    Gallery,
    Comment,
    Detail
  },
  data() {
    return {
      submited: false,
      loaded: false,
      blueprint: null
    }
  },
  computed: {
    title() {
      return 'Manufacture'
    },
    action() {
      return 'edit'
    },
    storeId() {
      return this.config?.storeId
    },
    manufactureId() {
      return this.config?.data?._id
    },
    getUri() {
      return `manufacture/get/${this.manufactureId}`
    },
    submitUri() {
      return `manufacture/update/${this.manufactureId}`
    },
    data() {
      return Object.assign(
        {
          more: {}
        },
        this.store.getter('', {})
      )
    },
    galleryConfig() {
      let gallery = Object.entries(Object.assign(this.data.thumbnail ? [this.data.thumbnail] : [], this.data.gallery)).reduce((result, [, value]) => {
        result.push({
          items: [value],
          group: 'gallery'
        })
        return result
      }, [])

      gallery = Object.values(this.data.designs || []).reduce((result, value) => {
        result.push({
          items: [value],
          group: 'blueprint'
        })
        return result
      }, gallery)

      gallery = Object.values(this.data.artworks || []).reduce((result, value) => {
        result.push({
          items: [value],
          group: 'artwork'
        })
        return result
      }, gallery)

      return {
        gallery,
        groups: {
          gallery: {
            label: 'Gallery',
            priority: 10
          },
          blueprint: {
            label: 'Blueprint',
            priority: 15
          },
          artwork: {
            label: 'Artwork',
            priority: 12
          }
        },
        config: {
          fullScreen: true,
          background: true,
          thumbnail: true,
          showLabel: true,
          default: {
            selected: {
              group: 'gallery'
            }
          }
        }
      }
    }
  },
  created() {
    this.store.commit('', {})
  },
  unmounted() {
    if (this.submited) {
      this.$emitter.emit('TableList.Refresh')
    }
  },
  methods: {
    setUpData(rawData) {
      if (rawData.status == 'success') {
        this.showModal = true
        this.store.commit('', rawData.data)
        this.loaded = true
      }
    }
  },
  props: {
    config: Object
  }
}
</script>
<style lang="scss">
.manufacture-form {
  .main-container {
    border-left: 1px solid #dfdfdf;
  }
  .gallery-container {
    flex: 1;
    height: 100vh;
    overflow: hidden;
  }
}
</style>
